import { useQuery } from '@tanstack/react-query';

import type { LeadPriorityScore, Signal } from '../../domain/signal';

import { leadScoringApi } from './api';
import { leadScoringQueryKey } from './leadScoringQueryKey';

export type UseLeadScoringQueryParams = {
  domain: string;
  score: LeadPriorityScore;
  triggeredSignals: readonly Signal[];
};

export const useLeadScoringQuery = (
  isEnabled: boolean,
  { domain, score, triggeredSignals }: UseLeadScoringQueryParams
) => {
  return useQuery({
    queryKey: leadScoringQueryKey.summary(
      domain,
      score,
      triggeredSignals.map((signal) => signal.id)
    ),
    queryFn: async () => {
      return await leadScoringApi.getSummary({ domain, score, triggeredSignals });
    },
    enabled: isEnabled,
  });
};
